import React from 'react';
import OperatorDetails from 'gatsby-matrix-theme/src/components/molecules/operator-details'

export default function index(props) {
  return (
    <OperatorDetails {...props} prettyLinkTracker={true} useOneStarRating={true} />
  )
}
